import * as React from "react";
import { IMAGE_PATH_PREFIX, PAGE_PATHS } from "./../../constants";
import { sendEmailOTP } from "../../api/auth/email/otp";
import { emailHasCorrectFormat } from "../../utils";
import { signInWithOTP } from "../../api/auth/signin";
import { Loading } from '../../components/elements'
type Props = {
    hideSignIn: () => void,
};

type State = {
    email: string,
    didEmailFail: boolean,
    didEmailValidationFail: boolean,
    didEmailAPIFail: boolean,
    didOtpFail: boolean,
    didOtpValidationFailed: boolean,
    didOTPApiFail: boolean,
    hasOtpMaxTriesReached: boolean,
    mode: "EMAIL" | "OTP",
    otp: string,
    loading: boolean
};

export default class SignInPopup extends React.PureComponent<Props, State> {
    private loginFlowId: string | undefined;

    constructor(props: Props) {
        super(props);
        this.state = {
            email: "",
            didEmailFail: false,
            didEmailValidationFail: false,
            didEmailAPIFail: false,
            didOtpFail: false,
            didOtpValidationFailed: false,
            didOTPApiFail: false,
            hasOtpMaxTriesReached: false,
            mode: "EMAIL",
            otp: "",
            loading: false
        };
    }



    getEmailInputSection = () => {
        return (
            <div
                className="border-box"
                id="sign-in-desktop-container">
                <div
                    id="sign-in-title-container">
                    <div
                        id="sign-in-title">
                        Sign-in
                    </div>
                    <img
                        onClick={this.onCloseClicked}
                        id="sign-in-close-icon"
                        src={IMAGE_PATH_PREFIX + "/static/assets/signInClose.png"} />
                </div>

                <div
                    style={{
                        marginTop: "30px",
                    }}
                    className="sign-in-field-container">
                    Email<span>*</span>
                </div>

                <div
                    style={{
                        marginTop: "10px",
                    }}
                    className="sign-in-form-input-container border-box">
                    <input
                        style={{
                            width: "100%",
                        }}
                        onChange={this.onEmailInputTextChanged}
                        type="text"
                        placeholder="Your email"
                        value={this.state.email}
                        name="sign-in-form-email-input"
                        className="sign-in-form-input border-box" />
                </div>

                {
                    this.state.didEmailFail &&
                    <div
                        id="sign-in-email-error">
                        Email not registered. Please use the correct email.
                    </div>
                }

                {
                    this.state.didEmailAPIFail &&
                    <div
                        id="sign-in-email-error">
                        Something went wrong, please try again
                    </div>
                }

                {
                    this.state.didEmailValidationFail &&
                    <div
                        id="sign-in-email-error">
                        Please enter a valid email
                    </div>
                }

                <div
                    id="sign-in-email-disclaimer">
                    •   Sign-in will require OTP from this email ID
                </div>

                <div
                    onClick={this.onEmailContinueClicked}
                    id="sign-in-continue-button">
                    Continue
                </div>
            </div>
        );
    }


    getOTPSection = () => {
        return (
            <div
                className="border-box"
                id="sign-in-desktop-container">
                <img
                    onClick={this.onCloseClicked}
                    id="sign-in-otp-close-icon"
                    src={IMAGE_PATH_PREFIX + "/static/assets/signInClose.png"} />

                <div
                    className="border-box"
                    id="sign-in-otp-title-container">
                    <img
                        src={IMAGE_PATH_PREFIX + "/static/assets/signInBack.png"}
                        id="sign-in-otp-back-icon"
                        onClick={this.onbackbuttonClicked} />
                    <div
                        id="sign-in-otp-title">
                        Sign-in
                    </div>
                </div>

                <div
                    className="border-box"
                    id="sign-in-otp-email-container">
                    {"OTP successfully sent to"}<br /><span>{this.state.email}</span>
                </div>

                <div
                    onClick={this.resendOTP}
                    className="border-box"
                    id="sign-in-otp-resend">
                    ↻ <span>resend</span>
                </div>

                <div
                    style={{
                        marginTop: "20px",
                    }}
                    className="sign-in-form-input-container border-box">
                    <input
                        style={{
                            width: "100%",
                        }}
                        onChange={this.onOTPInputTextChanged}
                        type="text"
                        placeholder="OTP"
                        value={this.state.otp}
                        name="sign-in-form-otp-input"
                        className="sign-in-form-input border-box" />
                </div>

                <div
                    id="sign-in-otp-error-sign-in-button-container">

                    {
                        this.state.didOtpValidationFailed &&
                        <div
                            className="sign-in-otp-error">
                            Please enter OTP
                        </div>
                    }

                    {
                        this.state.didOtpFail &&
                        <div
                            className="sign-in-otp-error">
                            Invalid OTP
                        </div>
                    }

                    {
                        this.state.hasOtpMaxTriesReached &&
                        <div
                            className="sign-in-otp-error">
                            You have entered an incorrect OTP too many times. Please resend OTP.
                        </div>
                    }

                    {
                        this.state.didOTPApiFail &&
                        <div
                            className="sign-in-otp-error">
                            Something went wrong, please try again
                        </div>
                    }

                    <img
                        onClick={this.onSignInClicked}
                        src={IMAGE_PATH_PREFIX + "/static/assets/signInButton.png"}
                        id="sign-in-otp-sign-in-button" />
                </div>
            </div>
        );
    }

    getMobileContent = () => {
        return (
            <div
                className="border-box"
                id="sign-in-mobile-tablet-container">
                <img
                    src={IMAGE_PATH_PREFIX + "/static/assets/signInDesktopIcon.png"}
                    id="sign-in-mobile-tablet-desktop-icon" />

                <div
                    id="sign-in-mobile-tablet-message">
                    Please use a desktop or a laptop computer to access your dashboard.
                </div>

                <div
                    onClick={this.onMobileOkClicked}
                    id="sign-in-mobile-tablet-button">
                    OK
                </div>
            </div>
        );
    }

    render() {
        if (this.state.loading) {
            return (
                <div
                    className="border-box"
                    id="sign-in-root">
                    <div
                        className="border-box"
                        id="sign-in-content-container-loading">
                        <Loading />
                    </div>
                </div>
            )
        } else {
            return (
                <div
                    className="border-box"
                    id="sign-in-root">
                    <div
                        className="border-box"
                        id="sign-in-content-container">

                        {
                            this.state.mode === "EMAIL" ?
                                this.getEmailInputSection()
                                :
                                this.getOTPSection()
                        }

                        {this.getMobileContent()}
                    </div>
                </div>
            );
        }
    }

    onEmailInputTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value.trim();
        this.setState(oldState => ({
            ...oldState,
            email: value,
        }));
    }

    onOTPInputTextChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
        let value = event.target.value.trim();
        this.setState(oldState => ({
            ...oldState,
            otp: value,
        }));
    }


    onEmailContinueClicked = () => {
        // Show invalid email error if validation fails
        if (!emailHasCorrectFormat(this.state.email)) {
            this.setState(oldState => ({
                ...oldState,
                didEmailFail: false,
                didEmailValidationFail: true,
            }));
            return;
        }

        // Else hide validation error if it was already shown
        this.setState(oldState => ({
            ...oldState,
            didEmailValidationFail: false,
            loading: true
        }), async () => {
            try {
                let emailOTPResponse = await sendEmailOTP(this.state.email);
                // Show email not registered error if email does not exist in our system
                if (!emailOTPResponse.emailExists) {
                    this.setState(oldState => ({
                        ...oldState,
                        didEmailFail: true,
                        loading: false
                    }));
                } else {
                    // Else hide email not registered error if it was already shown
                    this.loginFlowId = emailOTPResponse.loginFlowId;
                    this.setState(oldState => ({
                        ...oldState,
                        didEmailFail: false,
                        mode: "OTP",
                        loading: false
                    }));
                }
            } catch (e) {
                this.setState(oldState => ({
                    ...oldState,
                    didEmailFail: false,
                    didEmailValidationFail: false,
                    didEmailAPIFail: true,
                    loading: false
                }));
            }
        });
    }

    onSignInClicked = () => {
        // Reset all otp errors
        this.setState(oldState => ({
            ...oldState,
            didOtpFail: false,
            didOtpValidationFailed: false,
            hasOtpMaxTriesReached: false,
        }), async () => {
            // If otp is empty then show error
            if (this.state.otp === "") {
                this.setState(oldState => ({
                    ...oldState,
                    didOtpValidationFailed: true,
                    didOtpFail: false,
                }));

                return;
            }

            try {
                if (this.loginFlowId === undefined) {
                    throw new Error();
                }
                let signInWithOTPResponse = await signInWithOTP(this.loginFlowId, this.state.otp);

                if (!signInWithOTPResponse.otpCorrect && signInWithOTPResponse.numberOfTriesLeft !== 0) {
                    // otp is wrong but user has not entered the OTP too many times yet
                    this.setState(oldState => ({
                        ...oldState,
                        didOtpFail: true,
                    }));

                    return;
                } else if (!signInWithOTPResponse.otpCorrect && signInWithOTPResponse.numberOfTriesLeft === 0) {
                    // user has entered otp too many times
                    this.setState(oldState => ({
                        ...oldState,
                        hasOtpMaxTriesReached: true,
                    }));

                    return;
                }

                // otp entered correctly
                let win = window.open("/dashboard-saas", "_self");
                if (win !== null) {
                    win.focus();
                }
            } catch (e) {
                this.setState(oldState => ({
                    ...oldState,
                    didOtpFail: false,
                    didOtpValidationFailed: false,
                    didOTPApiFail: true,
                }));
            }
        });
    }

    resendOTP = () => {
        // reset otp errors
        this.setState(oldState => ({
            ...oldState,
            didOtpFail: false,
            didOtpValidationFailed: false,
            didOTPApiFail: false,
            hasOtpMaxTriesReached: false,
            otp: "",
        }), async () => {
            try {
                // send otp to email
                let emailOTPResponse = await sendEmailOTP(this.state.email);
                if (emailOTPResponse.emailExists) {
                    // store login flow id in memory for sending otp to server
                    this.loginFlowId = emailOTPResponse.loginFlowId;
                }
            } catch (e) {
                this.setState(oldState => ({
                    ...oldState,
                    didOTPApiFail: true,
                    didOtpFail: false,
                    didOtpValidationFailed: false,
                }));
            }
        });
    }

    onCloseClicked = () => {
        // TODO: analytics
        this.props.hideSignIn();
    }

    onMobileOkClicked = () => {
        // TODO: analytics
        this.props.hideSignIn();
    }

    onbackbuttonClicked = () => {
        this.setState({ mode: 'EMAIL' })
    }
}